/**
 * Yöneticinin müzakere katılımını işaretlemesi (mobildeki gibi): günü gelmiş
 * ya da geçmiş müzakerede isme basınca kardeş katıldı / katılmadı olur.
 */

/** Günü gelen ya da geçen müzakere işaretlenebilir. */
export function canMarkAttendance(muzakereDate, today) {
  return Boolean(muzakereDate) && String(muzakereDate) <= String(today);
}

/** Katılanlar listesinde üyeyi ekler ya da çıkarır (tekrar eklemez). */
export function toggleDoneIds(doneIds, memberId, done) {
  const rest = (doneIds || []).filter((id) => String(id) !== String(memberId));
  return done ? [...rest, memberId] : rest;
}
